import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';
import { cn } from '../common/utils';
import DropdownSelector from '../components/actions/DropdownSelector';
import {
  namedColorsGroups,
  namedColorsGroupSelectedId,
} from '../store/namedColors.state';

export type NamedColorGroupSelectorProps = {
  noSelectionTitle: string;
};
const NamedColorGroupSelector: React.FC<
  NamedColorGroupSelectorProps
> = props => {
  const { t } = useTranslation('app');
  const namedColorGroups = useRecoilValue(namedColorsGroups);
  const [selectedNamedColorGroup, setSelectedNamedColorGroup] = useRecoilState(
    namedColorsGroupSelectedId,
  );

  return (
    <DropdownSelector
      widthFull
      panelMode
      className={cn('px-1 py-1 ltr:ml-3 rtl:mr-3')}
      DropAlignLeft
      value={selectedNamedColorGroup}
      values={[null, ..._.keys(namedColorGroups)]}
      renderValue={id =>
        namedColorGroups?.[id]?.title ?? props.noSelectionTitle
      }
      onChange={groupId => setSelectedNamedColorGroup(groupId)}
    />
  );
};

export default NamedColorGroupSelector;
